<template>
  <div class="dashboard" >
    <div class="sidebaroverlay" :class="{'open' : menuState}"></div>
    <div class="sidebar" :class="{'open' : menuState}">
      <div class="syd-header">
        <div>
          <img src="@/assets/img/logo.png" class="logo-icon" alt="logo icon">
        </div>
        <div><h4 class="logo-text">UntraOffice</h4></div>
        <div class="mobile-toggle-icon ms-auto" @click="toggleMenu()">
          <svg fill="inherit" height="24px" width="24px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
            viewBox="0 0 460.775 460.775" xml:space="preserve">
            <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55
            c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55
            c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505
            c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55
            l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719
            c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z"/>
          </svg>
        </div>
      </div>
      <simplebar class="syd-nav">
        <ul class="navgroup">
          <li>
            <router-link  :to="{name : 'dashboard'}">
              <div v-html="icons.dashboard" class="p-icn"></div>
              <div class="menu-title">Dashboard</div>
            </router-link>
          </li>

          <div class="mgroup" ref="menuContainer">
            <li class="mlabel"> Team Management</li>
            <li v-if="hasPermission('Roles', 'view')">
              <router-link  :to="{name : 'roles'}">
                <div v-html="icons.roles" class="p-icn"></div>
                <div class="menu-title">Roles</div>
              </router-link>
            </li>
            <li v-if="hasPermission('Department', 'view')">
              <router-link  :to="{name : 'departments'}">
                <div v-html="icons.department" class="p-icn"></div>
                <div class="menu-title">Departments</div>
              </router-link>
            </li>
            <li v-if="hasPermission('Team', 'view')">
              <a href="javascript:void(0)" class="has-arrow" >
                  <div v-html="icons.customers" class="p-icn"></div>
                  <div class="menu-title">Staff Mgt.</div>
                </a>
                <ul class="submenu">
                  <li v-if="hasPermission('Team', 'view')">
                    <router-link  :to="{name : 'staff'}">
                      <div v-html="icons.circle" class="p-icn"></div>
                      <div class="menu-title">Staff List</div>
                    </router-link>
                  </li>
                </ul>
            </li>
          </div>

          <div class="mgroup" ref="menuContainer">
            <li class="mlabel">
              Office Tools
            </li>
            <li v-if="hasPermission('CRMs', 'view')">
              <a href="javascript:void(0)" class="has-arrow" >
                <div v-html="icons.customers" class="p-icn"></div>
                <div class="menu-title">{{ system.c }} Mgr</div>
              </a>
              <ul class="submenu">
                <li v-if="hasPermission('Customers List', 'view')">
                  <router-link  :to="{name : 'customerlist'}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">{{ system.c }} List</div>
                  </router-link>
                </li>
                <li v-if="hasPermission('Customers List', 'view') && system.sub">
                  <router-link  :to="{name : 'subpackage'}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">Subscription Package</div>
                  </router-link>
                </li>
              </ul>
            </li>



            <li v-if="hasPermission('Vendors Mgr', 'view')">
              <a href="javascript:void(0)" class="has-arrow" >
                <div v-html="icons.customers" class="p-icn"></div>
                <div class="menu-title">Vendor Mgr</div>
              </a>
              <ul class="submenu">
                <li v-if="hasPermission('Vendors List', 'view')">
                  <router-link  :to="{name : 'vendorslist'}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">Vendors List</div>
                  </router-link>
                </li>
              </ul>
            </li>




            <li v-if="hasPermission('Schedule','view')">
              <a href="javascript:void(0)" class="has-arrow" >
                <div v-html="icons.schedule" class="p-icn"></div>
                <div class="menu-title">Schedule Mgr.</div>
              </a>
              <ul class="submenu">
                <li v-if="false">
                  <router-link  :to="{name : 'mytasks'}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">My Calendar</div>
                  </router-link>
                </li>
                <li v-if="false">
                  <router-link  :to="{name : 'mytasks'}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">Team Calendar</div>
                  </router-link>
                </li>
                <li>
                  <router-link  :to="{name : 'myschedule'}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">My Schedule</div>
                  </router-link>
                </li>
                <li v-if="false">
                  <router-link  :to="{name : 'mytasks'}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">Requests</div>
                  </router-link>
                </li>
                <li v-if="false">
                  <router-link  :to="{name : 'mytasks'}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">Availablity</div>
                  </router-link>
                </li>
              </ul>
            </li>
            <li v-if="hasPermission('Task Management','view')">
              <a href="javascript:void(0)" class="has-arrow" >
                <div v-html="icons.task" class="p-icn"></div>
                <div class="menu-title">Task Manager</div>
              </a>
              <ul class="submenu">
                <li v-if="hasPermission('My Task', 'view')">
                  <router-link  :to="{name : 'mytasks'}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">My Tasks</div>
                  </router-link>
                </li>
                <li v-if="hasPermission('Project', 'view')">
                  <router-link  :to="{name : 'projectsview'}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">Projects</div>
                  </router-link>
                </li>
                <li v-if="hasPermission('CRMs', 'view') || hasPermission('Task Assignment', 'view')">
                  <router-link  :to="{name : 'tasksview', params: { project: 'work_order' } }">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">Work Order</div>
                  </router-link>
                </li>
                <li v-if="hasPermission('CRMs', 'view') || hasPermission('Task Assignment', 'view')">
                  <router-link  :to="{name : 'tasksview', params: { project: 'customer_complaints' } }">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">{{ system.c }} Complaints</div>
                  </router-link>
                </li>
              </ul>
            </li>
          </div>

          <div class="mgroup" ref="menuContainer" v-if="hasPermission('Accounting','view')">
            <li class="mlabel">
              Accounting
            </li>
            <li v-if="false">
              <router-link  :to="{name : 'dashboard'}">
                <div v-html="icons.dashboard" class="p-icn"></div>
                <div class="menu-title">Account Dashboard</div>
              </router-link>
            </li>
            <li v-if="hasPermission('Accounts','view') && (system.acct_type == '' || system.acct_type=='full')">
              <router-link  :to="{name : 'accounts'}">
                <div v-html="icons.accounts" class="p-icn"></div>
                <div class="menu-title">Accounts</div>
              </router-link>
            </li>
            <li v-if="hasPermission('Transactions','view')">
              <a href="javascript:void(0)" class="has-arrow" >
                <div v-html="icons.transactions" class="p-icn"></div>
                <div class="menu-title">Transactions</div>
              </a>
              <ul class="submenu">
                <li>
                  <router-link  :to="{name : 'transactions'}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">All Transactions</div>
                  </router-link>
                </li>
                <li>
                  <router-link  :to="{name : 'transactionreport'}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">Transaction Report</div>
                  </router-link>
                </li>
              </ul>
            </li>
            <li>
              <a href="javascript:void(0)" class="has-arrow" >
                <div v-html="icons.transactions" class="p-icn"></div>
                <div class="menu-title">Payroll</div>
              </a>
              <ul class="submenu">
                <li>
                  <router-link  :to="{name : 'paytemplate'}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">Pay Template</div>
                  </router-link>
                </li>
                <li>
                  <router-link  :to="{name : 'salarymgt'}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">Salary Mgt.</div>
                  </router-link>
                </li>
                <li>
                  <router-link  :to="{name : 'paysalary'}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">Pay Salary</div>
                  </router-link>
                </li>
              </ul>
            </li>
            <li>
              <a href="javascript:void(0)" class="has-arrow" >
                <div v-html="icons.transactions" class="p-icn"></div>
                <div class="menu-title">Invoices & Billing</div>
              </a>
              <ul class="submenu">
                <li>
                  <router-link  :to="{name : 'createinvoice'}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">Create Invoice</div>
                  </router-link>
                </li>
                <li>
                  <router-link  :to="{name : 'allinvoice'}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">All Invoice</div>
                  </router-link>
                </li>
                <li>
                  <router-link  :to="{name : 'invoices', params: { type: 'paid' } }">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">Paid Invoices</div>
                  </router-link>
                </li>
                <li>
                  <router-link  :to="{name : 'invoices', params: { type: 'pending' }}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">Pending Invoices</div>
                  </router-link>
                </li>
                <li>
                  <router-link  :to="{name : 'invoices', params: { type: 'overdue' }}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">Overdue Invoices</div>
                  </router-link>
                </li>
              </ul>
            </li>
            
          </div>
          
          <div class="mgroup" ref="menuContainer" v-if="user.persona != 'Sys Admin'">
            <li class="mlabel">
              User Account
            </li>
            <li>
              <a href="javascript:void(0)" class="has-arrow" >
                <div v-html="icons.profile" class="p-icn"></div>
                <div class="menu-title">Profile</div>
              </a>
              <ul class="submenu">
                <li>
                  <router-link  :to="{name : 'profile', params: { profileId: user.username, page:'personal_info' }}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">Personal Information</div>
                  </router-link>
                </li>
                <li>
                  <router-link  :to="{name : 'profile', params: { profileId: user.username, page:'skills' }}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">Skills and Qualifications</div>
                  </router-link>
                </li>
                <li>
                  <router-link  :to="{name : 'profile', params: { profileId: user.username, page:'office_info' }}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">Office Information</div>
                  </router-link>
                </li>
                <li>
                  <router-link :to="{name : 'profile', params: { profileId: user.username, page:'payment_info' }}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">Payment Info</div>
                  </router-link>
                </li>
                <li>
                  <router-link  :to="{name : 'profile', params: { profileId: user.username, page:'security' }}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">Security Settings</div>
                  </router-link>
                </li>
              </ul>
            </li>
          </div>

          <div class="mgroup" ref="menuContainer" v-if="hasPermission('Settings','view')">
            <li class="mlabel">
              Business Tools
            </li>
            <li>
              <a href="javascript:void(0)" class="has-arrow" >
                <div v-html="icons.customers" class="p-icn"></div>
                <div class="menu-title">Business Settings</div>
              </a>
              <ul class="submenu">
                <li v-if="hasPermission('Business Settings','view')">
                  <router-link  :to="{name : 'business_settings', params: {page:'business' }}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">Business Settings</div>
                  </router-link>
                </li>
                <li v-if="hasPermission('Accounting Settings','view')">
                  <router-link  :to="{name : 'business_settings', params: {page:'accounting' }}">
                    <div v-html="icons.circle" class="p-icn"></div>
                    <div class="menu-title">Accounting Settings</div>
                  </router-link>
                </li>
              </ul>
            </li>
          </div>
        </ul>
      </simplebar>
    </div>
  </div>
</template>
<script>
import icons from '@/assets/js/icons.js';
import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';
import { useStore } from 'vuex';
import { usePermissions } from '@/composables/usePermissions';
import { ref, onMounted,computed, toRefs  } from 'vue';
export default {
  name: 'DashboardView',
  components:{simplebar},
  props: ['menu'],
  setup(props,ctx){
    const store= useStore();
    const user = computed(() => store.state.User.user);
    const system = computed(() => store.state.System.system);
    const svgIcons = ref(icons);
    const menuContainer = ref([]);
    const { menu } = toRefs(props);
    const menuState = computed(() => menu.value);
    const { hasPermission } = usePermissions();
    function toggleMenu(){
        ctx.emit("toggleMenu");
      }
    onMounted(() => {
      var hasArrowElements=document.querySelectorAll('.has-arrow');
      hasArrowElements.forEach((el) => {
        el.addEventListener("click",()=>{
          var submenu=el.parentNode.querySelector(".submenu");
          submenu.style.maxHeight="0px"
          submenu.classList.toggle("show")
          submenu.style.maxHeight="200px"
          if(el.getAttribute("aria-expanded")){
            el.removeAttribute('aria-expanded')
          }else{
            el.setAttribute('aria-expanded',"true")
          }
        })
      });
    });
    return {user, icons: svgIcons.value, menuContainer,menuState,toggleMenu,hasPermission,
      system
     };
  }
}
</script>
<style lang="css" scoped>
.sidebar{height:100vh;
  width: 250px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  background-color: var(--white-color);
  border-right: 1px solid var(--bs-border-color);
  z-index: 11;
  box-shadow: 0 0.3rem 0.8rem rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;}

  .syd-header {
    width: 250px;
    height: 60px;
    display: flex;
    align-items: center;
    position: fixed;
    top: 0;
    bottom: 0;
    padding: 0 15px;
    z-index: 5;
    background-color: var(--white-color);
}
.syd-header img{width:30px}
.syd-header .logo-text {
  font-size: 22px;
  margin-left: 10px;
  margin-bottom: 0;
  letter-spacing: 1px;
  color: var(--primary-color);
}
.syd-header .mobile-toggle-icon {
  fill: var(--primary-color);
  border-radius: 50%;
  display: none;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: var(--white-color);
  cursor: pointer;
  transition: 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);
}
.syd-header .mobile-toggle-icon:hover{background-color: #f2f9ff;
    color: var(--primary-color);
}
.syd-header .mobile-toggle-icon svg{height:11px}

.syd-nav{height: calc(100vh - 60px);
  position: fixed; width:250px;
  top: 60px;}
.sidebar .navgroup, .sidebar ul{background: 0 0; margin: 0; list-style: none;
    display: flex; padding: 10px; flex-direction: column;}
.sidebar .navgroup li:first-child {margin-top: 5px;}
.sidebar .navgroup li {display: flex; flex-direction: column;
    position: relative; margin-top: 5px;}
.sidebar .navgroup a {position: relative;display: flex;
    align-items: center;justify-content: left; padding: 6px 16px;
    font-size: 14px; color: var(--black); fill: var(--black); stroke: var(--black); outline-width: 0;
    text-overflow: ellipsis; overflow: hidden; letter-spacing: 0.5px;
    border-radius: 0.25rem; transition: all 0.3s ease-out;}
.sidebar .navgroup  .p-icn {width: 24px; height:24px; line-height: 1;
  display: flex; align-items: center; justify-content: center;}
.sidebar .navgroup a .menu-title {margin-left: 10px;}
.sidebar .navgroup .router-link-active , .sidebar .navgroup a:active, .sidebar .navgroup a:focus, .sidebar .navgroup a:hover {
  color: var(--primary-color); fill: var(--primary-color); stroke: var(--primary-color);  text-decoration: none; 
  background-color: rgba(0, 140, 255, 0.05); font-size: 15px;}
.sidebar .mlabel {padding: 20px 15px 5px 5px; color: #b0afaf;
    text-transform: uppercase; font-size: 12px; letter-spacing: 0.5px;}
.sidebar .has-arrow:after {position: absolute; content: "";
  width: .5em; height: .5em; border-style: solid; border-width: 1px 0 0 1px; border-color: initial;right: 1em;
  transform: rotate(-45deg) translateY(-50%);transform-origin: top;
  top: 50%;transition: all .3s ease-out;}
.sidebar .has-arrow[aria-expanded=true]:after, .sidebar .router-link-active>.has-arrow:after {
    transform: rotate(-135deg) translateY(-50%);}
.sidebar .submenu{padding:0; font-size:13px}
.sidebar .submenu:not(.show) {display: none;}
.sidebar .submenu li a{font-size:14px}
.sidebar .submenu .p-icn{padding:5px}
.sidebar{-webkit-transition: -webkit-transform .3s cubic-bezier(.32, 1.25, .375, 1.15);
    -moz-transition: -moz-transform .3s cubic-bezier(.32, 1.25, .375, 1.15);
    -o-transition: -o-transform .3s cubic-bezier(.32, 1.25, .375, 1.15);
    transition: transform .3s cubic-bezier(.32, 1.25, .375, 1.15);}
.sidebar:not(.open){transform: translate(-250px,0);}
@media screen and (max-width: 700px) {
  .sidebar {transform: translate(-250px, 0px);}
  .sidebar:not(.open){transform: translate(0px,0);}
}
</style>
